import { ReactElement } from "react";
import { Button, Card, Stack, Text, Title } from "@mantine/core";
import ErrorMessage from "@common/components/text/ErrorMessage/ErrorMessage";
import { formatPrice } from "@common/utils/string";
import useChangePlanWithInstanceRestart from "@hooks/useChangePlanWithInstanceRestart";
import {
  IAddOnContext,
  IFlatAddOnDescriptor,
  IMeteredAddOnDescriptor,
} from "../../types";

export function SwitchToMeteredTransformsCTA({
  legacy,
  metered,
}: {
  legacy: IAddOnContext<IFlatAddOnDescriptor>;
  metered: IAddOnContext<IMeteredAddOnDescriptor>;
}): ReactElement | null {
  const {
    mutate: changePlan,
    isPending: isChangingPlan,
    isUpdatingSubscription,
    error: changePlanError,
  } = useChangePlanWithInstanceRestart(legacy.purchase);

  // the legacy card only mounts this once subscribed and offered; the
  // catalogue row is the one thing it cannot vouch for
  if (!metered.addOn) {
    return null;
  }

  const includedUnits = metered.getIncludedUnits();

  return (
    <Card withBorder bg="gray.1" mt="xs">
      <Stack spacing="xs">
        <Title order={4} size="h5" mb={0}>
          Transforms, for less
        </Title>
        <Text c="gray.4" size="sm">
          Instead of a monthly fee, we now bill transforms at{" "}
          {formatPrice(metered.getPricePerUnit())} per run, so you only pay for
          the transforms you run.
          {includedUnits > 0 &&
            ` You get ${includedUnits.toLocaleString()} runs included for free.`}
        </Text>
        <Button
          mt="xs"
          loading={isUpdatingSubscription}
          disabled={isChangingPlan}
          onClick={() =>
            changePlan({
              ...legacy.getDisableAddOnPayload(),
              ...metered.getEnableAddOnPayload(),
            })
          }
        >
          Switch to pay-per-run billing
        </Button>
        <ErrorMessage error={changePlanError} />
      </Stack>
    </Card>
  );
}
